import styled from 'styled-components/macro';

export const Content = styled.div<{ showSidebar: number }>`
    flex-grow: 1;
    padding: 24px;
    margin-top: 128px;
    max-width: 100%;
    height: calc(100% - 128px);
    overflow: auto;
    //@media (max-width: 600px) {
    //    margin-top: 40px;
    //}
    @media (min-width: 960px) {
        ${props => props.showSidebar ? 'max-width: calc(100% - 280px);' : ''}
    }
`;

export const MainContainer = styled.div`
    display: flex;
    overflow: hidden;
    height: 100%;
`;
